import React, { useEffect } from 'react';
import { makeStyles } from 'react-scale/components/design-system';
import Markdown from '@scale/frontend-lib/markdown';

interface TextAttachmentProps {
  text: string;
  onLoadOrError?: (error: boolean) => void;
}

const Text: React.FC<TextAttachmentProps> = ({ text, onLoadOrError }) => {
  const styles = useStyles();

  useEffect(() => {
    if (onLoadOrError) {
      return onLoadOrError(true);
    }
  });

  return (
    <div
      className={styles.attachmentMarkdown}
      dangerouslySetInnerHTML={{ __html: Markdown.render(text) }}
    ></div>
  );
};

const useStyles = makeStyles({
  attachmentMarkdown: {
    '& tr': {
      border: '1px solid rgba(0, 0, 0, 0.3)',
    },
    '& tr:nth-child(even)': {
      backgroundColor: '#f2f2f2',
    },
    '& th': {
      border: '1px solid rgba(255, 255, 255, 0.3)',
      padding: '6px 10px',
      backgroundColor: '#222',
      color: 'white',
    },
    '& td': {
      border: '1px solid rgba(0, 0, 0, 0.3)',
      padding: '10px',
    },
  },
});

export default Text;
